(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-experience"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const cleanups = [];
    const listen = (el, type, fn, options) => { el.addEventListener(type, fn, options); cleanups.push(() => el.removeEventListener(type, fn, options)); };

    // Matieres : une photo et une legende actives a la fois.
    root.querySelectorAll('[data-material]').forEach(button => listen(button, 'click', () => {
      const index = button.dataset.material;
      root.querySelectorAll('[data-material]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      root.querySelectorAll('[data-material-photo], [data-material-copy]').forEach(el => {
        const active = (el.dataset.materialPhoto ?? el.dataset.materialCopy) === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-hidden', String(!active));
      });
      const counter = root.querySelector('[data-material-count]');
      if (counter) counter.textContent = '0' + (Number(index) + 1);
    }));

    // Gestes d'atelier : la video se charge et joue seulement a l'ecran.
    const videos = [...root.querySelectorAll('[data-ax-video]')];
    videos.forEach(video => {
      const load = () => { const source = video.querySelector('source'); if (source && !source.src) { source.src = source.dataset.src; video.load(); } };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting && !motion.matches && !document.hidden) { load(); video.play().catch(() => {}); }
          else video.pause();
        }), { threshold: .35 });
        observer.observe(video);
        cleanups.push(() => { observer.disconnect(); video.pause(); });
      }
    });
    listen(document, 'visibilitychange', () => { if (document.hidden) videos.forEach(v => v.pause()); });
    listen(motion, 'change', () => { if (motion.matches) videos.forEach(v => v.pause()); });

    // Ancres du parcours : defilement doux, focus sur la cible.
    root.querySelectorAll('a[href^="#"]').forEach(link => listen(link, 'click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      history.replaceState(null, '', link.hash);
      target.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'start' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }));

    root.axCleanup = () => { cleanups.forEach(fn => fn()); delete root.dataset.initialized; };
  };
  document.querySelectorAll('[data-apex-experience]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-apex-experience]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-apex-experience]').forEach(root => root.axCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-parcours-config-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apex-config-cards')) {
    class ApexConfigCards extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.apcc-card'));
        this.buttons = Array.from(this.querySelectorAll('.apcc-trigger'));
        this.activeIndex = Math.max(0, this.cards.findIndex((card) => card.classList.contains('is-active')));
        this.speed = Number(this.dataset.speed) || 5000;
        this.classList.add('is-paused');
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            this.openCard(index);
            this.userPaused = true;
            this.stopAutoplay();
          });
        });
        this.addEventListener('focusin', () => {
          this.userPaused = true;
          this.stopAutoplay();
        });
        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.startAutoplay();
          } else {
            this.stopAutoplay();
          }
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.observer) this.observer.disconnect();
      }

      openCard(index) {
        this.activeIndex = index;
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === index;
          const button = this.buttons[cardIndex];
          const panel = card.querySelector('.apcc-drawer');
          card.classList.toggle('is-active', active);
          button.setAttribute('aria-expanded', String(active));
          panel.hidden = !active;
        });
      }

      startAutoplay() {
        const desktop = window.matchMedia('(min-width: 769px)').matches;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay !== 'true' || !desktop || reducedMotion || this.timer || this.userPaused) return;
        this.classList.remove('is-paused');
        this.timer = window.setInterval(() => {
          this.openCard((this.activeIndex + 1) % this.cards.length);
        }, this.speed);
      }

      stopAutoplay() {
        this.classList.add('is-paused');
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('apex-config-cards', ApexConfigCards);
  }

  } catch(e) { console.error(e); }
})();
})();
